import React, { memo } from "react";

function BannerInstalarApp({
  appInstalada,
  mensajeInstalacion,
  onInstalarApp,
}) {
  if (appInstalada) {
    return null;
  }

  return (
    <>
      <div
        style={{
          backgroundColor: "#FF9900",
          color: "#fff",
          padding: "10px 16px",
          textAlign: "center",
          fontSize: "13px",
          fontWeight: "700",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <span>
          📲 ¡Disfruta la experiencia completa desde nuestra App Móvil!
        </span>

        <button
          type="button"
          onClick={onInstalarApp}
          style={{
            backgroundColor: "#111",
            color: "#fff",
            padding: "5px 12px",
            borderRadius: "8px",
            border: "none",
            fontSize: "11px",
            fontWeight: "800",
            display: "inline-block",
            transition: "0.2s",
            cursor: "pointer",
          }}
        >
          INSTALAR APP
        </button>
      </div>

      {mensajeInstalacion && (
        <div
          style={{
            backgroundColor: "#fff7e6",
            color: "#7a4b00",
            padding: "8px 14px",
            fontSize: "12px",
            fontWeight: "800",
            textAlign: "center",
            borderBottom: "1px solid #f3dfb5",
          }}
        >
          {mensajeInstalacion}
        </div>
      )}
    </>
  );
}

export default memo(BannerInstalarApp);
